import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { IMAGES, PHONE_TEL } from "./data";

const LINKS = [
  { label: "Products", href: "#products" },
  { label: "About", href: "#about" },
  { label: "Applications", href: "#applications" },
  { label: "App", href: "#app" },
  { label: "Quotation", href: "#quotation" },
  { label: "Contact", href: "#contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled || open
          ? "border-b border-emerald-900/40 bg-[#050B07]/85 backdrop-blur-md"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="container mx-auto flex h-16 items-center justify-between px-4 sm:px-6 lg:h-20 lg:px-8">
        <a href="#home" data-testid="nav-logo-link" className="flex items-center gap-3" onClick={() => setOpen(false)}>
          <img src={IMAGES.logo} alt="KARM INDUSTRIES logo" className="h-10 w-10 rounded-full object-cover lg:h-12 lg:w-12" />
          <span className="font-display text-sm font-bold tracking-[0.18em] text-white lg:text-base">
            KARM <span className="text-emerald-400">INDUSTRIES</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-desktop-links">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-slate-300 transition-colors duration-300 hover:text-emerald-400"
            >
              {l.label}
            </a>
          ))}
          <a
            href={PHONE_TEL}
            data-testid="nav-call-button"
            className="flex items-center gap-2 rounded-full bg-emerald-500 px-5 py-2.5 text-sm font-bold text-[#050B07] transition-transform duration-300 hover:scale-105 hover:bg-emerald-400"
          >
            <Phone className="h-4 w-4" /> Call Now
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="text-white lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-emerald-900/40 bg-[#050B07]/95 backdrop-blur-md lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-1 px-6 py-6">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="rounded-lg px-3 py-3 text-base font-medium text-slate-200 transition-colors hover:bg-emerald-950/60 hover:text-emerald-400"
                onClick={() => setOpen(false)}
              >
                {l.label}
              </a>
            ))}
            <a
              href={PHONE_TEL}
              data-testid="nav-mobile-call-button"
              className="mt-3 flex items-center justify-center gap-2 rounded-full bg-emerald-500 px-5 py-3 text-base font-bold text-[#050B07]"
            >
              <Phone className="h-4 w-4" /> Call 8989099599
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
